// src/hooks/useLocationSearch.js
import { useState, useEffect, useRef } from "react";
import { googleMapsLoader } from "../googleMaps";

let autocompleteService = null;

export default function useLocationSearch(initialQuery = "", coords = null) {
    const [searchQuery, setSearchQuery] = useState(initialQuery);
    const [suggestions, setSuggestions] = useState([]);
    const debounceRef = useRef(null);

    // 1) Ensure the Google API is loaded, then grab the AutocompleteService
    useEffect(() => {
        googleMapsLoader.load().then(() => {
            autocompleteService = new window.google.maps.places.AutocompleteService();
        });
    }, []);

    // 2) Reverse-geocode to seed the box
    useEffect(() => {
        if (!coords) return;
        googleMapsLoader.load().then(() => {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode(
                { location: { lat: coords.lat, lng: coords.lng } },
                (results, status) => {
                    if (status === "OK" && results[0]) {
                        setSearchQuery(results[0].formatted_address);
                    }
                }
            );
        });
    }, [coords]);

    // 3) Debounced place-predictions
    useEffect(() => {
        if (!autocompleteService || searchQuery.length < 3) {
            setSuggestions([]);
            return;
        }
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            autocompleteService.getPlacePredictions(
                {
                    input: searchQuery,
                    types: ["establishment", "geocode"],
                    ...(coords
                        ? {
                            location: new window.google.maps.LatLng(
                                coords.lat,
                                coords.lng
                            ),
                            radius: 50000,
                        }
                        : {}),
                },
                (predictions, status) => {
                    if (status === "OK") setSuggestions(predictions);
                    else setSuggestions([]);
                }
            );
        }, 200);
    }, [searchQuery, coords]);

    return { searchQuery, setSearchQuery, suggestions };
}
